import React from 'react'
import PropTypes from 'prop-types'
import { v4 as uuidv4 } from 'uuid'
import { Outer, Fold } from './CardlessTrifold.styles'

const CardlessTrifold = ({ iconsArr }) => {
  return (
    <Outer>
      {iconsArr.map((obj) => (
        <Fold headW={obj.headW} maxW={obj.maxW} key={uuidv4()}>
          {obj.icon}
          <h3>{obj.head}</h3>
          <p>{obj.sub}</p>
        </Fold>
      ))}
    </Outer>
  )
}

CardlessTrifold.propTypes = {
  iconsArr: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default CardlessTrifold
